import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";

import IllPerimetro from "../../../assets/images/pagina_5_italia.svg";

export default function Sezione3popup2Grecia({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Consolidation area", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Consolidation area"
    >
      <div
        className="
          relative w-full md:w-[1280px] bg-white shadow-2xl
          max-h-[90vh] overflow-y-auto overscroll-contain
        "
        style={{ background: "#E8F7FD", WebkitOverflowScrolling: "touch" }}
      >
        {/* Azioni in alto */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("Sezione3popup2Grecia")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="relative w-full flex flex-col items-center p-8 md:p-10">
          {/* Illustrazione + titolo + testo: tutto dentro un wrapper di larghezza nota,
              così il margine negativo in % è relativo a questa larghezza (800px) */}
          <div className="relative w-full max-w-[800px]">
            <img src={IllPerimetro} alt="" className="block w-full h-auto" />

            {/* "Services Holding" — bianco, dentro il cerchio navy (posizione in %) */}
            <span className="absolute left-[49%] top-[11%] md:top-[20%] -translate-x-1/2 text-white font-bold text-center leading-[1.05] text-[16px] md:text-[26px]">
              Services<br />Holding
            </span>

            {/* Testo che scende sotto, tirato su nell'area vuota dell'SVG (mt negativo in %, responsive) */}
            <div className="relative z-10 -mt-[50%] pb-4 text-center text-[#0E3761]">
              <p className="font-bold text-[20px] leading-[24px] md:text-[28px] md:leading-[34px]">
                Establishment of<br />Reale Services Srl
              </p>

              <p className="hidden md:block text-[16px] leading-[24px] md:text-[24px] md:leading-[28px] mt-5">
                On 2 December, the Articles of Association of<br/>Reale Services Srl were finalised — a holding<br/>
                company wholly owned (100%) by the parent<br/>company Società Reale Mutua di Assicurazioni<br/>
                and dedicated to the pure holding and control<br/>of investments in Group companies operating<br/>
                mainly in the services sector, in particular in the<br/>healthcare, wellbeing and living property areas,<br/>
                also with a view to facilitating and enabling the<br/>entry of companies to be acquired in the future.
              </p>

              <p className="block md:hidden text-[16px] leading-[24px] md:text-[24px] md:leading-[28px] mt-5">
                On 2 December, the Articles of Association of Reale Services Srl were finalised — a holding
                company wholly owned (100%) by the parent company Società Reale Mutua di Assicurazioni
                and dedicated to the pure holding and control of investments in Group companies operating
                mainly in the services sector, in particular in the healthcare, wellbeing and living property
                areas, also with a view to facilitating and enabling the entry of companies to be acquired
                in the future.
              </p>
            </div>
          </div>
        </div>

        </div>
    </div>,
    document.body
  );
}
